import { Fragment, useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { Loading } from '@autopass-web/mochi-component';

import { PATHS } from '../const';
import { useMounted } from '../hooks/use-mounted';
import { sessionStorageController } from '../services/storages';
import { useInsuranceForms } from '../services/use-insurance-forms';

export const StepCheckContainer = ({
  children,
  hasChecked: _hasChecked = false,
}: {
  children: React.ReactNode;
  hasChecked?: boolean;
}): React.ReactElement => {
  const mounted = useMounted();
  const { replace } = useRouter();
  const [hasChecked, setHasChecked] = useState(_hasChecked);

  const { insuranceForms, isGetInsuranceFormsFetching } = useInsuranceForms({
    enabled: mounted && !!sessionStorageController.getToken(),
    refetchOnMount: true,
  });

  useEffect(() => {
    if (!mounted || isGetInsuranceFormsFetching || hasChecked) return;

    const check = async () => {
      setHasChecked(true);
      await navigateUser();
    };

    const navigateUser = async () => {
      const token = sessionStorageController.getToken();

      if (token == null) {
        await replace(PATHS.INDEX);
        return;
      }

      const form = insuranceForms[0];

      if (form == null) {
        await replace(PATHS.ONBOARDING_ADD_PLATE_NUMBER);
        return;
      }

      const { insurance_form_status } = form;

      switch (insurance_form_status) {
        case 'INITIALIZED':
          await replace(PATHS.ONBOARDING_PROCESS);
          break;
        case 'DRAFTED':
          await replace(PATHS.ONBOARDING_PROCESS);
          break;
        case 'FAILED':
          await replace(PATHS.ONBOARDING_PROCESS);
          break;
        case 'USER_SUBMITTED':
          await replace(PATHS.ONBOARDING_VERIFIED_SUCCESS);
          break;
        default:
          break;
      }
    };

    check();
  }, [
    mounted,
    insuranceForms,
    replace,
    hasChecked,
    isGetInsuranceFormsFetching,
  ]);

  if (!hasChecked) return <Loading />;

  return <Fragment>{children}</Fragment>;
};
